import { EnumLanguage } from '@libs/constants';
import { Util } from '@libs/utilities/util';

import { KeywordExtractor, IKeywordExtractOptions, EnumKeywordExtractSorting, IKeywordWithCount } from '../keyword-extractor';


export class WorkbenchKeywordExtractor {

	constructor(
		private keywordExtractor: KeywordExtractor
	) {}

	extractKeywordsFromArray(sentences: string[], language: EnumLanguage): string[] {
		const combinedSentence: string = sentences.join(' ');
		return this.extractKeywords(combinedSentence, language);
	}

	extractKeywords(sentence: string, language: EnumLanguage): string[] {

		//0 - define the keyword extraction options
		const options: Partial<IKeywordExtractOptions> = {
			language			: language,
			removeDigits 		: true,
			removeDuplicates 	: true,
			minLength 			: 3,
			minOccurrenceCount	: 2,
			sorting				: EnumKeywordExtractSorting.OccurrenceDesc
		};

		//1 - extract the keywords
		return this.keywordExtractor.extractKeywords(sentence, options);
	}

	extractWordsCount(keywords: string[], language: EnumLanguage): IKeywordWithCount[] {

		//0 - combine the keywords to one sentence
		const sentence: string = keywords.join(', ');

		//1 - define the keyword extraction options
		const options: Partial<IKeywordExtractOptions> = {
			language			: language,
			removeDigits 		: true,
			removeDuplicates 	: false,
			chainedWords		: false,
			minLength 			: 3,
			minOccurrenceCount	: 2,
			sorting				: EnumKeywordExtractSorting.OccurrenceDesc
		};

		//2 - extract the single keywords with count
		return this.keywordExtractor.extractKeywordsWithCount(sentence, options);
	}


	/**------------------------------------------------------
	 * Extract Short Tail Keywords
	 */
	extractShortTailKeywords(sentence: string, language: EnumLanguage): string[] {
		return this.extractShortTailKeywordsWithCount(sentence, language)
			.map((elem: IKeywordWithCount) => elem.keyword);
	}

	extractShortTailKeywordsWithCount(sentence: string, language: EnumLanguage): IKeywordWithCount[] {

		//0 - extract short tail keywords
		const simpleKeywords: IKeywordWithCount[] = this.keywordExtractor.extractKeywordsWithCount(sentence, {
			language 			: language,
			removeDigits 		: false,
			removeDuplicates 	: true,
			chainedWords		: false,
			minLength 			: 2,
			minOccurrenceCount	: 2
		});

		//1 - filter out all keywords which are not short tail
		const shortTailKeywords: IKeywordWithCount[] = simpleKeywords.filter((elem: IKeywordWithCount) => Util.Text.cleanText(elem.keyword).split(' ').length === 1);
		return shortTailKeywords;
	}


	/**------------------------------------------------------
	 * Extract Long Tail Keywords
	 */
	extractLongTailKeywords(sentence: string, language: EnumLanguage): string[] {
		return this.extractLongTailKeywordsWithCount(sentence, language)
			.map((elem: IKeywordWithCount) => elem.keyword);
	}

	extractLongTailKeywordsWithCount(sentence: string, language: EnumLanguage): IKeywordWithCount[] {

		//0 - extract long tail keywords
		const wordCombinationKeywords: IKeywordWithCount[] = this.keywordExtractor.extractKeywordsWithCount(sentence, {
			language			: language,
			removeDigits 		: false,
			removeDuplicates 	: true,
			chainedWords		: true
		});

		//1 - filter out all keywords which are not long tail
		const longTailKeywords: IKeywordWithCount[] = wordCombinationKeywords.filter((elem: IKeywordWithCount) => Util.Text.cleanText(elem.keyword).split(' ').length > 1);
		return longTailKeywords;
	}
}
